import {MarkerClusterer} from '@googlemaps/markerclusterer';
import haversine from 'haversine';

window.haversine = haversine;

class BranchesMap {

    constructor(options) {
        this.branches            = [];
        this.currentBranch       = null;
        this.autocompleteElement = null;
        this.map                 = null;
        this.filters             = {
            hq:     false,
            agency: false,
            atm:    false
        };

        Object.assign(this, options);

        this.init();
    }

    init() {
        this.extendMaps();

        // Reusable info window
        this.infoWindow = this.getInfoWindow();

        // Hydrate markers and group in clusters
        this.markers   = this.branches.map(b => this.placeMarker(b));
        this.clusterer = new MarkerClusterer(
            {
                markers: [],
                map:     this.map
            });
        this.initFilters();
        this.filterMarkers();

        if (this.currentBranch) {
            /** @type {google.maps.Marker} */
            this.focusBranch(this.currentBranch.id);
        } else {

            // Set "you are here" marker
            this.setCurrentPositionMarker();

            // Move map to center on the current position marker, but a bit lower
            this.map.panToWithOffset(this.currentPositionMarker.getPosition(), 0, -100);

            // Geolocate user
            this.locate();
        }
    }

    initFilters() {
        /**
         * Add DOM event listeners
         */
        const watchFilters = _qa('#map-filters input[type="checkbox"]');
        const applyFilter  = input => {
            this.setFilter(input.name, input.checked);
        };
        watchFilters.forEach(input => {
            applyFilter(input);

            input.addEventListener('change', e => {
                applyFilter(e.target);
                this.filterMarkers();
            });
        });
    }

    extendMaps() {
        // Get a reference to the branches object
        const _this = this;

        this.map.addListener('click', function(e) {
            _this.infoWindow.close();
        });

        google.maps.Map.prototype.setBounds = function(markers) {

            let bounds = new google.maps.LatLngBounds();
            bounds.extend(_this.getCurrentPosition());
            try {
                for (let i = 0; i < markers.length; i++) {
                    bounds.extend(markers[i].getPosition());
                }
            } catch (e) {
                console.log(e);
            }


            this.fitBounds(bounds);
        };

        google.maps.Marker.prototype.showAddress = function() {
            const address = this.address;
            const svg     = _q(address ? '#smiling' : '#dizzy').innerHTML;
            const content = _q('#info-template').innerHTML.replace(':svg', svg).replace(':address', address ?? 'Nu am putut determina adresa ta');
            _this.infoWindow.setContent(content);
            _this.infoWindow.open(this.map, this);
        };

        google.maps.Marker.prototype.geocoded = function(address) {
            this.address = address;
            this.showAddress();
            // _this.updated();
            if (_this.autocompleteElement) {
                _this.autocompleteElement.value = address ?? '';
            }
        };

        google.maps.Map.prototype.panToWithOffset = function(latLng, offsetX, offsetY) {
            const map = this;
            const ov  = new google.maps.OverlayView();
            ov.onAdd  = function() {
                const proj   = this.getProjection();
                const aPoint = proj.fromLatLngToContainerPixel(latLng);
                aPoint.x     = aPoint.x + offsetX;
                aPoint.y     = aPoint.y + offsetY;
                map.panTo(proj.fromContainerPixelToLatLng(aPoint));
            };
            ov.draw   = function() {
            };
            ov.setMap(this);
        };

        if (this.autocompleteElement) {
            const autocomplete = new google.maps.places.Autocomplete(this.autocompleteElement, {
                componentRestrictions: {
                    country: 'RO'
                }
            });

            autocomplete.addListener('place_changed', () => {
                const place = autocomplete.getPlace();
                if (place.geometry) {
                    this.setCurrentPositionMarker(place.geometry.location);
                    this.updated();
                }
            });

            this.autocomplete = autocomplete;
        }
    }

    //////
    /// GETTERS
    //////

    //////
    /// GETTERS AND SETTERS
    //////

    getEnabledMarkers() {
        if (!this.markers) return [];

        return this.markers.filter(marker => marker.branch.type.split(',').some(type => this.filters[type.replace(/\s/g, '')]));
    }

    getInfoWindow() {
        return new google.maps.InfoWindow({
                                              content:        '',
                                              disableAutoPan: true
                                          });
    }

    getMarkerContent(marker) {
        const template                     = _q('#infowindow-template').content.firstElementChild.cloneNode(true), branch = marker.branch;
        _q(template, '.title').innerHTML   = branch.name;
        _q(template, '.address').innerHTML = [
            branch.address,
            branch.city,
            branch.county
        ].join(', ');
        if (branch.phone) {
            _q(template, '.phone-wrapper').href      = 'tel:' + branch.phone;
            _q(template, '.phone').innerHTML = branch.phone;
        } else {
            _q(template, '.phone-wrapper').remove();
        }
        _q(template, '.hours').innerHTML = branch.hours;
        _q(template, '.route').href      = _q(template, '.route')
            .href
            .replace(':lat', branch.lat)
            .replace(':lng', branch.lng + '/' + (this.getCurrentPosition().toString() ?? ''));
        if (branch.type.includes('agency') || branch.type.includes('hq')) {
            _q(template, '.schedule').href = _q(template, '.schedule').href.replace(':slug', branch.id + '-' + branch.slug);
        } else {
            _q(template, '.schedule').remove();
        }
        return template.outerHTML;
    }

    getCurrentPosition() {
        return this.currentPosition ?? this.map.getCenter();
    }

    setCurrentPosition(position) {
        this.currentPosition = position;
    }

    getCurrentPositionMarker() {
        if (!this.currentPositionMarker) {
            const currentPositionMarker = new google.maps.Marker(
                {
                    map:       this.map,
                    draggable: true,
                    icon:      window.icons.here
                });

            const _this = this;
            google.maps.event.addListener(currentPositionMarker, 'dragend', function(e) {
                _this.setCurrentPosition(e.latLng);
                window.geocodePosition(e.latLng, address => this.geocoded(address));
                _this.updated();
            });
            google.maps.event.addListener(currentPositionMarker, 'click', function(e) {
                this.showAddress();
            });

            this.currentPositionMarker = currentPositionMarker;
        }

        return this.currentPositionMarker;
    }

    setCurrentPositionMarker(position) {
        this.setCurrentPosition(position || this.map.getCenter());
        const currentPositionMarker = this.getCurrentPositionMarker();
        currentPositionMarker.setPosition(this.getCurrentPosition());
        this.updated();
        window.geocodePosition(currentPositionMarker.getPosition(), address => currentPositionMarker.geocoded(address));
    }

    setFilter(type, value) {
        this.filters[type] = value;
    }

    //////
    /// METHODS
    //////

    locate(callback) {
        const handleLocationError = (browserHasGeolocation, infoWindow, pos) => {
            infoWindow.setPosition(pos);
            infoWindow.setContent(browserHasGeolocation ? 'Error: The Geolocation service failed.' : 'Error: Your browser doesn\'t support geolocation.');
            infoWindow.open(branches.map);
        };

        const toggleLoadingClass = () => {
            document.querySelectorAll('[name=localize] > *').forEach(el => el.classList.toggle('animate-spin'));
        };

        // Try HTML5 geolocation.

        if (navigator.geolocation) {
            toggleLoadingClass();
            navigator.geolocation.getCurrentPosition((position) => {
                const pos = {
                    lat: position.coords.latitude,
                    lng: position.coords.longitude
                };
                this.setCurrentPositionMarker(new google.maps.LatLng(pos));
                toggleLoadingClass();

                if (callback) {
                    callback();
                }
            }, () => {
                handleLocationError(true, infoWindow, this.map.getCenter());
                toggleLoadingClass();
            });
        } else {
            // Browser doesn't support Geolocation
            handleLocationError(false, this.infoWindow, this.map.getCenter());
        }
    }

    filterMarkers() {
        const markers = this.getEnabledMarkers();
        this.clusterer.clearMarkers();
        this.clusterer.addMarkers(markers);
        this.updated();
    }

    focusBranch(id) {
        id           = parseInt(id, 10);
        const marker = this.markers.find(m => m.id === id);

        if (marker) {
            this.showInfoWindow(marker);
        }
    }

    placeMarker(b) {

        const types = b.type.split(',').map(t => t.replace(/\s/g, ''));

        const marker = new google.maps.Marker(
            {
                position: {
                    lat: b.lat,
                    lng: b.lng
                },
                title:    b.name,
                branch:   b,
                id:       b.id,
                icon:     types.includes('hq') ? window.icons.hq : types.includes('agency') ? window.icons.agency : window.icons.atm
            });

        marker.addListener('click', () => this.showInfoWindow(marker));
        return marker;
    };

    showInfoWindow(marker) {
        this.map.panToWithOffset(marker.position, 0, -110);
        this.infoWindow.setContent(this.getMarkerContent(marker));
        this.infoWindow.open(this.map, marker);

        const b = _q('#branches-current .branch-element[data-branch="' + marker.id + '"]');

        if (b) {
            // b.scrollIntoView({behavior: 'smooth', block: 'nearest', inline: 'start'});
            b.siblings(true).forEach(s => {
                s.classList.remove('active');
            });
            b.classList.add('active');
            b.scrollInListSmoothly(() => _q('.search-branches').classList.add('show-map'));
        }
    }

    updated() {
        const markers  = this.getEnabledMarkers();
        const position = this.getCurrentPosition();
        const template = _q('#branch-template').innerHTML;
        const list     = _q('#branches-current');
        const sorted   = markers.map(marker => {
            marker.distance = haversine(position.toJSON(), marker.getPosition().toJSON(), {
                format: '{lat,lng}',
                unit:   'km'
            });

            return marker;
        }).sort((a, b) => a.distance - b.distance);

        if (this.getCurrentPosition() && sorted.length > 0) {
            const next    = sorted[0];
            const nextest = sorted.slice(0, 3).filter(m => m.id !== next.id && m.distance < 5);
            this.map.setZoom(18);
            this.map.setBounds(
                [
                    next,
                    ...nextest
                ]);
        }

        list.innerHTML = sorted.map(marker => {
            const branch = marker.branch;
            return template.replaceAll(':name', branch.name)
                           .replaceAll(':slug', branch.slug)
                           .replaceAll(':branch', marker.id)
                           .replaceAll(':address', branch.address)
                           .replaceAll(':city', branch.city)
                           .replaceAll(':county', branch.county)
                           .replaceAll(':lat', branch.lat)
                           .replaceAll(':lng', branch.lng + '/' + position.toString())
                           .replaceAll(':distance', marker.distance.toFixed(2));
        }).join('\n');

        const listElement = _q('.branches-list');
        if (listElement) {
            sorted.forEach(marker => {
                const dstElement = _q(listElement, 'div[data-branch="' + marker.id + '"] .distance');
                if (dstElement) {
                    dstElement.innerHTML = dstElement.innerHTML.replace(':distance', marker.distance.toFixed(2));
                }
            });
        }

        Array.from(list.children).forEach(b => {
            b.addEventListener('click', () => {
                this.focusBranch(b.dataset.branch);
            });
        });

    }
}

export default BranchesMap;
